// Round transparent icon button with the house `hover` wash — the recipe the
// PageSlot pane header (Back / Forward / Expand / Split / Fullscreen /
// Minimize / Close) and the MinimizedDock dismiss use. Promoted to shared
// 2026-07-12 (/simplify review); the same shape used to exist inline in
// CanvasSplitView.CloseBtn and the HeaderTabs / AppHeader circle buttons.
//
// F2 "one close button" (Nika 2026-08-16): re-based on brand `IconButton`
// with the exact geometry of brand `CloseButton` — `controlHCompact` (36px)
// circle, `iconSm` (16px) glyph, no fill at rest, `hover` wash, caption→title
// ink — so a PageSlot / MinimizedDock X is pixel-identical to every other
// sidebar and modal X. Consumers keep passing their own `Icon` (name); an
// `Icon` override that only names the glyph inherits `iconSm` from here.
// Touch controls use the standard controlH box so adjacent targets do not
// overlap. Fine-pointer desktop controls keep the compact house geometry.
// IconButton also brings the accessible name: a reactive `aria-label` that
// follows the `title` (or a name the call site declares). Fixed-px on purpose —
// device-physical chrome must not scale with the surface's font size
// (sizes.js §3/§6).
// Tooltips (2026-09-02 per Nika "add tooltips to pageslot header icons"):
// the house plugin surface, not the native delayed title. Consumers keep
// passing `title`; the brand `TitleTooltipTrigger` hands it to the plugin and
// keeps the native attribute off so the two surfaces never double up. Hosts
// without a shell-mounted TooltipRoot simply never receive openTooltip — the
// same graceful degrade every NavbarButton consumer already relies on.
//
// This file used to carry a VERBATIM paste of the NavbarButton bridge (a
// one-shot `onRender` copy of the title into `tooltipText` and `aria-label`).
// The copy froze both at the FIRST render's language — English on a Georgian
// boot — and, being a paste, it missed the brand fix that retired the same
// copy there (3.14.791). The bridge is one brand component now; this button
// keeps no copy of it (pageSlotHeaderBtnTooltip.test.js).
export const PageSlotHeaderBtn = {
  extends: ['IconButton', 'AppControl', 'TitleTooltipTrigger'],
  compact: true,
  theme: 'transparent',
  type: 'button',
  boxSize: 'controlHCompact',
  padding: '0',
  round: '50%',
  flexShrink: '0',
  align: 'center center',
  background: 'transparent',
  color: 'inactive',
  cursor: 'pointer',
  transitionProperty: 'background, color',
  transition: 'A defaultBezier',
  ':hover': { background: 'hover', color: 'title' },
  '@coarse': {
    boxSize: 'controlH',
    ':after': { inset: '0' }
  },
  Icon: {
    boxSize: 'iconSm',
    display: 'block',
    flexShrink: '0'
  }
}
